import {ActionHandlerBase} from "../action-handler-base";
import {IRegistrationActionPayload} from "@sparkware/uc-sdk-core";

export class RegistrationActionHandler extends ActionHandlerBase<IRegistrationActionPayload> {
    async handle(payload: IRegistrationActionPayload): Promise<void> {
        await this.services.externalLinks.openMembership({
            marketingParams: {
                wtc: payload.actionData?.wtc,
                dl: payload.actionData?.dl
            }
        })
    }

}